import styled from 'styled-components';
import { Button, lightenDarkenColor } from '../shared/utils/styles';

export const ButtonContainer = styled.div`
display: none;
@media (max-width: 1024px) {
  display: block;
  & button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 8px;
    height: 30px;
    border: 1px solid gray;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    & i {
      padding-right: 5px;
      font-size: 1.2em;
    }
  }
}
`;

export const StyledButton = styled(Button)`
  font-weight: normal;
  padding: 4px 8px;
  height: 30px;
  background-color: #0095E8;
  color: #fff;
  &:hover {
    background-color: ${lightenDarkenColor('#0095E8', 20)};
    color: #ffffff;
  }
`;
